// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1ojRr","label":"Section_label__2rwxq","contentWrap":"Section_contentWrap__2pSgt","footer":"Section_footer__1lNEV","footerInner":"Section_footerInner__3sHTX"};